// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"TFBFileInput_inputLabel__2BKie","inputGroup":"TFBFileInput_inputGroup__2grrL","tfbInputFileContainer":"TFBFileInput_tfbInputFileContainer__3in-_"};